import React, {useEffect} from "react";
import "./ImageEmbedPreview.css";

const ImageEmbedPreview = ({
    previewOptions,
    setData,
    editMode = true,
    triggerResize,
}) => {
    useEffect(() => {
        triggerResize?.(); // Trigger on mount
    }, []);

    return (
        <>
            <div className="link-tool text-left pb-5">
                {/* Delete Button */}
                {editMode && (
                    <button
                        type="button"
                        onClick={() => setData("embed", null)}
                        className="absolute -top-3 -left-3 z-10 w-6 h-6 bg-red text-white text-xs rounded-full flex items-center justify-center shadow hover:bg-red-600"
                    >
                        ✕
                    </button>
                )}
                <a
                    className="link-tool__content link-tool__content--rendered bg-white dark:bg-boxdark rounded shadow font-light text-gray-600 dark:text-gray-300"
                    // target="_blank"
                    rel="nofollow noindex noreferrer"
                    href={previewOptions.href}
                >
                    <div
                        className="link-tool__image"
                        style={{
                            backgroundImage: `url(${previewOptions.imageUrl})`,
                        }}
                    ></div>
                    <div className="link-tool__title">
                        {previewOptions.title}
                    </div>
                    <p className="link-tool__description">
                        {previewOptions.description}
                    </p>
                    <span className="link-tool__anchor">
                        {previewOptions.href}
                    </span>
                </a>
            </div>
        </>
    );
};

export default ImageEmbedPreview;
